import { EpocusRole } from "elephant-web/gql";

export type PerformanceVariant = "performer" | "reviewer";

/*
 * Deliberately NOT a capability. `viewOwnPerformance` already grants every
 * ePOCUS role access to this route, so there is nothing to authorise here —
 * this only picks which stats are worth showing. Adding it to
 * `_lib/rbac/capabilities.ts` would put a presentation concern in a table that
 * mirrors backend grants 1:1 (see PNE-562).
 *
 * QA Admin and Program Admin resolve to "reviewer" because they hold
 * `submitReview` but not `createEncounter` — the performer variant renders
 * empty for them.
 */
const REVIEWER_VARIANT_ROLES = new Set<EpocusRole>([
  EpocusRole.Reviewer,
  EpocusRole.QaAdmin,
  EpocusRole.ProgramAdmin,
]);

export const getPerformanceVariant = (
  role: EpocusRole | null,
): PerformanceVariant =>
  role !== null && REVIEWER_VARIANT_ROLES.has(role) ? "reviewer" : "performer";
